import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { Button } from '@carto/meridian-ds/components'
import useOnboardingChecklist from 'features/onboarding-checklist/utils/useOnboardingChecklist'
import { useAppSelector } from 'app/state'

export function OnboardingChecklistFooter() {
  const { skipOnboarding } = useOnboardingChecklist()
  const { tasks, completed } = useAppSelector((state) => state.onboardingChecklist)

  if (completed || !tasks) return null

  return (
    <Box p={2} pb={1} pt={0} aria-label="onboarding-checklist-footer">
      <Button
        sx={{ maxWidth: 'unset' }}
        color="primary"
        onClick={skipOnboarding}
        aria-label="onboarding-checklist-footer-button"
      >
        <FormattedMessage id="home.onboarding.checklist.skipLink" />
      </Button>
    </Box>
  )
}

export default OnboardingChecklistFooter
